interface EditadoPorRodapeProps {
  dados: {
    editadoPor?: {
      username?: string;
    };
    editadoEm?: Date | string;
  };
}

/**
 * Texto do rodapé que exibe quem editou o registro pela última vez.
 * @param dados
 * @returns
 */
export function EditadoPorRodape({ dados: { editadoPor: editadoPor, editadoEm: editadoEm } }: EditadoPorRodapeProps) {

  let nome;
  if (editadoPor)
    nome = `Última alteração por ${editadoPor.username ?? ''}`

  let data;
  if (editadoEm) {
    data = editadoEm ? ' em '.concat(
      new Date(editadoEm).toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }),
    )
      : '';
  }

  return (
    <div className="col-md-12 text-end align-bottom mt-2">
      <span className="float-right">
        {nome} {data}
      </span>
      <hr />
    </div>
  );
}
